import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import moment, { Moment } from "moment";
import { getDeviceList_returns_data_item as Device } from "../api/getDeviceList";

export interface IInputState {
  device: Device | null;
  selectedDate: Moment;
  selectedHour: number;
}

const InitialInputState: IInputState = {
  device: {
    aqi: 57,
    dev_id: "6629968",
    district: "Howrah",
    id: 345,
    last_online: "2025-06-17T12:52:28.000Z",
    lat: "22.6188730",
    location: "Anandanagar Panchayat",
    long: "88.3218710",
    pm25: "27.57",
    stncode: "DXAQMS-288",
  },
  selectedDate: moment(),
  selectedHour: moment().subtract(1, "hour").hour(),
};

export const InputSlice = createSlice({
  name: "input",
  initialState: InitialInputState,
  reducers: {
    changeDevice: (state: IInputState, action: PayloadAction<Device>) => {
      state.device = action.payload;
      return state;
    },
    changeSelectedDate: (state: IInputState, action: PayloadAction<Moment>) => {
      state.selectedDate = action.payload;
      return state;
    },
    changeSelectedHour: (state: IInputState, action: PayloadAction<number>) => {
      state.selectedHour = action.payload;
      return state;
    },
  },
});

export const { changeDevice, changeSelectedDate, changeSelectedHour } =
  InputSlice.actions;
export const InputReducer = InputSlice.reducer;
